import { Component, ViewChild, TemplateRef } from "@angular/core";
import { HttpEventType } from "@angular/common/http";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { FormatosService } from "../../../../shared/services/formatos.service";
import { DigitalesService } from "../../../../shared/services/digitales.service";
import { DigitalesPesv, DigitalesPesvService } from "../../../../shared/services/digitales-pesv.service";
import { AdministracionService } from "../../../../shared/services/administracion.services";
import { Administracion } from "../../../../shared/model/administracion.model";
import { AuthService } from "../../../../shared/services/auth.service";
import { LiderazgoPesvService } from "../../../../shared/services/liderazgoPesv.service";
import { Subject, takeUntil, Subscription } from "rxjs";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { EstadosDocumentoService } from "../../../../shared/services/estados-documento.service";
import { gpcGoogleService } from "../../../../shared/services/gpcGoogle.service";
import { GoogleStoragePreviewService } from "../../../../shared/services/google-storage-preview.service";

function normalize(str: any) {
  return str
    ? str
        .toString()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/\s+/g, " ")
        .trim()
    : "";
}

interface ArchivoPesvCard {
  id: number;
  nombre: string;
  prefijo: string;
  file: File | null;
  formatos?: string[];
  formatosLabel?: string;
}

@Component({
  selector: "app-liderazgo-compromiso",
  templateUrl: "./liderazgo-compromiso.component.html",
  styleUrls: ["./liderazgo-compromiso.component.scss"],
})
export class LiderazgoCompromisoComponent {
   Math = Math;
  readonly PUNTO_LIDERAZGO = 5;
  readonly NOMBRE_DOCUMENTO_LIDERAZGO_ID = 5;

  formLiderazgo!: FormGroup;
  formEditarLiderazgo!: FormGroup;
  modalEditarLiderazgoRef: any;
  cargandoEditarLiderazgo = false;
  cargando = false;
  cargandoHistorial = false;
  historialActas: any[] = [];
  nombreDocumentoLiderazgoActivo: any | null = null;
  maestroLiderazgoActivo: any | null = null;
  usuarioLogin: any;
  tabActivo: number = 1;
  editando: boolean = false;
  page1: number = 1;
  pageSize1: number = 10;
  searchTextHistorialLiderazgo = "";
  fechaDesignacionMax = "";
  fechaVencimientoMin = "";
  descargandoLiderazgo = false;
  versionPreview = false;
  descargaCancelada = false;
  descargaActivaSub: Subscription | null = null;
  documento_id: number | null = null;
  private vistaPreviaLiderazgo = false;
  private descargaLiderazgoCancel$ = new Subject<void>();
  pdfFileSelected: File | null = null; // Archivo PDF seleccionado

  pdfUrl: SafeResourceUrl | null = null;
  @ViewChild('modalVisualizarLiderazgo') modalVisualizarLiderazgo!: TemplateRef<any>;

  archivoSeleccionado: File | null = null;
  archivoSeleccionadoEditar: File | null = null;
  archivoDigitalLiderazgo: ArchivoPesvCard = {
    id: 4,
    nombre: "Liderazgo y Compromiso",
    prefijo: "LCC",
    file: null,
    formatos: ["pdf", "doc", "docx"],
    formatosLabel: "pdf/doc/docx",
  };
  configuracionDigitalLiderazgo: DigitalesPesv | null = null;
  formatosPermitidosLiderazgo: string[] = ["pdf", "doc", "docx"];
  subiendoArchivo = false;
  progresoSubida = 0;
  mensajeSubida = "";
  estadoSubida: "" | "subiendo" | "exito" | "error" = "";
  administraciones: Administracion[] = [];
  empresaNit: string | null = null;
  private adminCargada = false;
  private configuracionCargada = false;
  private historialInicialCargado = false;
  private liderazgoEditandoId: number | string | null = null;
  private liderazgoVersionOriginal: string | null = null;
  estadosPolitica: EstadosDocumentoService[] = [];
  consecutivoLiderazgo: any;
  fechaActual: string = new Date().toISOString().split('T')[0];
  actaVigenteExiste!: boolean;
  page = 1;
  pageSize = 10;

  constructor(
    private formatosService: FormatosService,
    private digitalesService: DigitalesService,
    private digitalesPesvService: DigitalesPesvService,
    private liderazgoPesvService: LiderazgoPesvService,
    
    private administracionesService: AdministracionService,
    private authService: AuthService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private estadoDocumentosService:EstadosDocumentoService,
    private gpcGoogle: gpcGoogleService,
    private googleStoragePreview: GoogleStoragePreviewService,
  ) {}

  ngOnInit(): void {
    
    this.formLiderazgo = this.fb.group({
      version: ["", Validators.required],      
      fecha: ["", Validators.required],      
      consecutivo: ["", Validators.required],      
      estado: ["", Validators.required],
      observaciones: [""],
    });

    this.formEditarLiderazgo = this.fb.group({
      version: ["", Validators.required],
      fecha_designacion: ["", Validators.required],
    });

    this.inicializarFechasLiderazgo();
    this.documento_id = this.NOMBRE_DOCUMENTO_LIDERAZGO_ID;
    this.usuarioLogin = this.authService.getCurrentUserValue();
    this.getEstadoDocumento();
    this.cargarDataAdmin();
    this.cargarConsecutivos();
    this.cargarHistorialActas ();
                    
  }

  // ✅ Cargar NIT de la empresa para usar en descargas y subidas a Digitales PESV
  private cargarNitEmpresa(): void {
    this.administracionesService.obtenerTodas().subscribe({
      next: (res: any) => {
        const lista = Array.isArray(res) ? res : Array.isArray(res?.administraciones) ? res.administraciones : [];
        if (lista.length > 0) {
          this.empresaNit = lista[0].nit?.toString() || null;
          console.log('🏢 NIT de la empresa cargado:', this.empresaNit);
        }
      },
      error: (err: any) => {
        console.error('❌ Error al cargar NIT de la empresa:', err);
      },
    });
  }

  private inicializarFechasLiderazgo(): void {
    const hoy = new Date();
    this.fechaDesignacionMax = this.formatearFechaParaInput(hoy);
    this.fechaVencimientoMin = "";
  }

  private formatearFechaParaInput(fecha: Date): string {
    const ano = fecha.getFullYear();
    const mes = String(fecha.getMonth() + 1).padStart(2, "0");
    const dia = String(fecha.getDate()).padStart(2, "0");
    return `${ano}-${mes}-${dia}`;
  }

  private normalizarFechaParaInput(fecha: any): string {
    if (!fecha) {
      return "";
    }

    const valor = String(fecha);
    if (/^\d{4}-\d{2}-\d{2}$/.test(valor)) {
      return valor;
    }

    const d = new Date(fecha);
    if (Number.isNaN(d.getTime())) {
      return "";
    }

    return this.formatearFechaParaInput(d);
  }




  private normalizarVersionLiderazgo(version: string): string {
    return String(version || "")
      .trim()
      .replace(/[^a-zA-Z0-9_.-]/g, "_")
      .replace(/_+/g, "_")
      .replace(/^_|_$/g, "")
      .toUpperCase();
  }



 

  private construirNombreArchivoDocumentoLiderazgo(file: File, version: string): string {
    const extension = file.name.split(".").pop()?.toLowerCase() || "bin";
    const versionNorm = this.normalizarVersionLiderazgo(version) || "SIN_VERSION";
    return `LIDERAZGO_${versionNorm}.${extension}`;
  }

  get acceptDocumentoLiderazgo(): string {
    if (!this.formatosPermitidosLiderazgo.length) {
      return ".pdf,.doc,.docx";
    }
    return this.formatosPermitidosLiderazgo.map((f) => `.${f}`).join(",");
  }

  get formatosPermitidosLiderazgoTexto(): string {
    return this.formatosPermitidosLiderazgo.map((f) => `.${f}`).join(", ");
  }

  get historialPoliticasVista(): any[] {
    const base = this.historialActas || [];
    const search = normalize(this.searchTextHistorialLiderazgo);

    if (!search) {
      return base;
    }

    return base.filter((item: any) => {
      const version = normalize(item?.version || "");
      const fechaDesignacion = normalize(this.formatDateTodo(item?.fecha_designacion));
      const estado = this.esLiderazgoActivo(item) ? "activa" : "inactiva";
      return (
        version.includes(search) ||
        fechaDesignacion.includes(search) ||
        estado.includes(search)
      );
    });
  }

  aplicarFiltroHistorialLiderazgo(): void {
    this.page1 = 1;
  }

  exportarHistorialLiderazgoExcel(): void {
    const datos = this.historialPoliticasVista || [];
    if (!datos.length) {
      Swal.fire("Info", "No hay datos para exportar", "info");
      return;
    }

    const filas = datos.map((item: any) => ({
      VERSION: item?.version || "",
      DESIGNACION: this.formatDateTodo(item?.fecha_designacion),
      ESTADO: this.esLiderazgoActivo(item) ? "ACTIVA" : "INACTIVA",
    }));

    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(filas);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Liderazgo");
    XLSX.writeFile(wb, `historial_liderazgo_${Date.now()}.xlsx`);
    Swal.fire("Exito", "Exportacion a Excel completada", "success");
  }

  exportarHistorialLiderazgoPdf(): void {
    const datos = this.historialPoliticasVista || [];
    if (!datos.length) {
      Swal.fire("Info", "No hay datos para exportar", "info");
      return;
    }

    const doc = new jsPDF("p", "pt");
    doc.setFontSize(12);
    doc.text("Historial de Liderazgo y Compromiso", 40, 35);

    autoTable(doc, {
      head: [["VERSION", "DESIGNACION", "ESTADO"]],
      body: datos.map((item: any) => [
        item?.version || "",
        this.formatDateTodo(item?.fecha_designacion),
        this.esLiderazgoActivo(item) ? "ACTIVA" : "INACTIVA",
      ]),
      startY: 50,
      styles: { fontSize: 9 },
      headStyles: { fillColor: [13, 110, 253] },
    });

    doc.save(`historial_liderazgo_${Date.now()}.pdf`);
    Swal.fire("Exito", "Exportacion a PDF completada", "success");
  }

 formatDateTodo(fecha: any): string {
    if (!fecha) return "N/A";
    const d = new Date(fecha);
    return `${String(d.getUTCDate()).padStart(2, "0")}/${String(d.getUTCMonth() + 1).padStart(2, "0")}/${d.getUTCFullYear()}`;
  }

  onTabChange(event: any): void {
    this.tabActivo = event.nextId;

    if (this.tabActivo === 1 && this.historialActas.length === 0 && !this.cargandoHistorial) {
    //  this.cargarHistorialPoliticas();
    }
  }






  cambiarEstadoPolitica(item: any, activar: boolean): void {
    if (!item || item.id == null) {
      Swal.fire("Error", "No se encontro el identificador de liderazgo y compromiso.", "error");
      return;
    }

    const yaEnEstadoObjetivo = activar ? this.esLiderazgoActivo(item) : !this.esLiderazgoActivo(item);
    if (yaEnEstadoObjetivo) {
      Swal.fire("Info", activar ? "Liderazgo y compromiso ya esta activo." : "Liderazgo y compromiso ya esta inactivo.", "info");
      return;
    }

    Swal.fire({
      title: "Confirmar accion",
      text: activar ? "¿Deseas activar liderazgo y compromiso?" : "Deseas inactivar liderazgo y compromiso?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Si",
      cancelButtonText: "No",
    }).then((result) => {
      if (!result.isConfirmed) {
        return;
      }

      const request$ = activar
        ? this.liderazgoPesvService.activar(item.id)
        : this.liderazgoPesvService.inactivar(item.id);

      request$.subscribe({
        next: () => {
          item.estado = activar ? 1 : 0;
          Swal.fire("Exito", activar ? "Liderazgo activado correctamente." : "Liderazgo inactivado correctamente.", "success");
          this.cargarHistorialActas();
        },
        error: (err) => {
          Swal.fire("Error", this.obtenerMensajeError(err, "No se pudo cambiar el estado."), "error");
        },
      });
    });
  }

  puedeEditarLiderazgo(acta: any): boolean {
    if (!acta) return false;
    const nombreEstado = acta?.estadoDocumento?.nombre ? String(acta.estadoDocumento.nombre).toLowerCase().trim() : "";
    
    const estadosPermitidos = ["borrador", "revision", "en revisión"];
    return estadosPermitidos.some(estado => nombreEstado.includes(estado));
  }

  puedeRechazarLiderazgo(acta: any): boolean {
    if (!acta) return false;
    const idEstado = acta?.estadoDocumento?.id;
    const estadosPermitidos = [1, 2, 3]; // 1: Borrador, 2: En Revisión, 3: Vigente
    return estadosPermitidos.includes(idEstado);
  }

  editarLiderazgoDesdeHistorial(item: any): void {
    if (!item || item.id == null) {
      Swal.fire("Error", "No se encontro el identificador de liderazgo y compromiso.", "error");
      return;
    }

    const estado = Number(item?.estado);
    const estadosPermitidos = [1, 2];

    console.log("Estado del liderazgo a editar:", estado, "Permitidos:", estadosPermitidos);

    if (!estadosPermitidos.includes(estado)) {
      Swal.fire(
        "Info",
        "Solo se pueden editar registros en estado Borrador o Revisión.",
        "info"
      );
      return;
    }

    console.log("Preparando formulario de edición para liderazgo:", item);

    this.liderazgoEditandoId = item.id;
    this.liderazgoVersionOriginal = this.normalizarVersionLiderazgo(item.version || "");
    this.archivoSeleccionadoEditar = null;

    this.formLiderazgo.patchValue({
      version: item.version || "",
      fecha: this.normalizarFechaParaInput(item.fecha),
      observaciones: item.observaciones || "",
      estado: item.estado || "",
      consecutivo: item.consecutivo || "",
    });
    this.editando = true;
    this.tabActivo = 1;

  }

  abrirModalEditarLiderazgo(template: any): void {
    this.modalEditarLiderazgoRef = this.modalService.open(template, { centered: true, size: "lg" });
    this.modalEditarLiderazgoRef.result.finally(() => {
      this.archivoSeleccionadoEditar = null;
      this.formEditarLiderazgo.reset();
      this.liderazgoEditandoId = null;
      this.liderazgoVersionOriginal = null;
    });
  }

  guardarCambiosLiderazgo(modal: any): void {
    if (!this.formEditarLiderazgo.valid) {
      this.formEditarLiderazgo.markAllAsTouched();
      Swal.fire("Validacion", "Completa todos los campos requeridos", "warning");
      return;
    }

    if (!this.liderazgoEditandoId) {
      Swal.fire("Error", "No se encontro el identificador de liderazgo y compromiso.", "error");
      return;
    }

    const version = this.normalizarVersionLiderazgo(this.formEditarLiderazgo.get("version")?.value);
    const fechaDesignacion = String(this.formEditarLiderazgo.get("fecha_designacion")?.value || "").trim();
    const archivoEditar = this.archivoSeleccionadoEditar;
    const requiereSubidaArchivo = !!archivoEditar;
    const versionOriginal = this.liderazgoVersionOriginal || "";
    const editarSinCambioDeVersion = !!versionOriginal && version === versionOriginal;

    if (requiereSubidaArchivo && !this.empresaNit) {
      Swal.fire("Error", "No se pudo obtener el NIT de la empresa para cargar el documento.", "error");
      return;
    }

    if (!version || !fechaDesignacion) {
      Swal.fire("Error", "Version y fecha de designacion son obligatorias", "error");
      return;
    }

    this.liderazgoPesvService.getAll().subscribe({
      next: (items: any[]) => {
        const existeVersion = (Array.isArray(items) ? items : []).find(
          (it: any) => this.normalizarVersionLiderazgo(it?.version || "") === version,
        );

        const versionDuplicada = !!existeVersion && String(existeVersion?.id) !== String(this.liderazgoEditandoId);
        if (versionDuplicada) {
          Swal.fire("Version duplicada", `La version ${version} ya existe. Cambia la version para poder guardar.`, "warning");
          return;
        }

        this.cargandoEditarLiderazgo = true;
        const payload = editarSinCambioDeVersion
          ? {
              fecha_designacion: fechaDesignacion,
            }
          : {
              version,
              fecha_designacion: fechaDesignacion,
            };

        const nombreCarpeta = this.empresaNit
          ? `${this.empresaNit}/pesv/documental/acta/liderazgo/${version}/`
          : "";
        const nombreArchivo = archivoEditar ? this.construirNombreArchivoDocumentoLiderazgo(archivoEditar, version) : "";
        const prefijo = "ACTAS";
        const idNumerico = Number(this.archivoDigitalLiderazgo.id || 4);

        this.liderazgoPesvService.update(this.liderazgoEditandoId as string | number, payload).subscribe({
          next: () => {
            if (!requiereSubidaArchivo) {
              this.cargandoEditarLiderazgo = false;
              Swal.fire("Exito", "Liderazgo y compromiso actualizado correctamente", "success");
              this.liderazgoEditandoId = null;
              this.liderazgoVersionOriginal = null;
              this.archivoSeleccionadoEditar = null;
              this.formEditarLiderazgo.reset();
              this.cargarHistorialActas();
            //  this.cargarHistorialPoliticas();
              modal.dismiss();
              return;
            }

            this.digitalesService.subirArchivo(archivoEditar as File, idNumerico, nombreCarpeta, nombreArchivo, prefijo).subscribe({
              next: (event) => {
                if (event.type === HttpEventType.UploadProgress && event.total) {
                  this.progresoSubida = Math.round((100 * event.loaded) / event.total);
                } else if (event.type === HttpEventType.Response) {
                  this.cargandoEditarLiderazgo = false;
                  Swal.fire("Exito", "Liderazgo y compromiso actualizado correctamente", "success");
                  this.liderazgoEditandoId = null;
                  this.liderazgoVersionOriginal = null;
                  this.archivoSeleccionadoEditar = null;
                  this.formEditarLiderazgo.reset();
                  //  this.cargarHistorialPoliticas();
                  modal.dismiss();
                }
              },
              error: () => {
                this.cargandoEditarLiderazgo = false;
                Swal.fire("Error", "Se actualizo el registro, pero no se pudo reemplazar el documento.", "error");
                //  this.cargarHistorialPoliticas();
              },
            });
          },
          error: (err) => {
            this.cargandoEditarLiderazgo = false;
            Swal.fire("Error", this.obtenerMensajeError(err, "No se pudo actualizar liderazgo y compromiso"), "error");
          },
        });
      },
      error: (err) => {
        Swal.fire("Error", this.obtenerMensajeError(err, "No se pudo validar versiones de liderazgo"), "error");
      },
    });
  }

  esLiderazgoActivo(item: any): boolean {
    return this.normalizarActivo(item);
  }

  private obtenerMensajeError(err: any, porDefecto: string): string {
    const mensaje = err?.error?.message || err?.error?.error || err?.message || porDefecto;

    if (typeof mensaje !== "string") {
      return porDefecto;
    }

    if (mensaje.toLowerCase().startsWith("http failure response for")) {
      return porDefecto;
    }

    return mensaje;
  }

  private normalizarActivo(template: any): boolean {
    const valor = template?.activo ?? template?.estado ?? template?.isActivo ?? template?.estadoActivo;

    if (typeof valor === "boolean") {
      return valor;
    }

    if (typeof valor === "number") {
      return valor === 1;
    }

    if (typeof valor === "string") {
      return ["1", "true", "activo", "active", "si", "sí"].includes(valor.trim().toLowerCase());
    }

    return false;
  }

  private cargarDataAdmin(): void {
    this.administracionesService.obtenerTodas().subscribe({
      next: (data) => {
        this.administraciones = data;
        this.empresaNit = this.administraciones[0]?.nit ? String(this.administraciones[0].nit) : null;
        this.adminCargada = true;
      //  this.intentarCargarHistorialInicial();
      },
      error: () => {
        this.adminCargada = true;
      //  this.intentarCargarHistorialInicial();
      },
    });
  }

  onFileChange(event: any): void {
    const file: File = event.target.files[0];
    if (!file) return;

    const extension = file.name.split(".").pop()?.toLowerCase();
    const formatos = this.formatosPermitidosLiderazgo;

    if (!extension || !formatos.includes(extension)) {
      Swal.fire("Formato invalido", `Solo se aceptan: ${this.formatosPermitidosLiderazgoTexto || ".pdf, .doc, .docx"}`, "warning");
      event.target.value = "";
      return;
    }

    this.archivoSeleccionado = file;
    this.archivoDigitalLiderazgo.file = file;
    this.estadoSubida = "";
    this.mensajeSubida = "";
    this.progresoSubida = 0;
    event.target.value = "";
  }

  onFileChangeEditar(event: any): void {
    const file: File = event.target.files[0];
    if (!file) return;

    const extension = file.name.split(".").pop()?.toLowerCase();
    const formatos = this.formatosPermitidosLiderazgo;

    if (!extension || !formatos.includes(extension)) {
      Swal.fire("Formato invalido", `Solo se aceptan: ${this.formatosPermitidosLiderazgoTexto || ".pdf, .doc, .docx"}`, "warning");
      event.target.value = "";
      return;
    }

    this.archivoSeleccionadoEditar = file;
    event.target.value = "";
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    const target = event.currentTarget as HTMLElement;
    target.classList.add("drag-over");
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    const target = event.currentTarget as HTMLElement;
    target.classList.remove("drag-over");
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    const target = event.currentTarget as HTMLElement;
    target.classList.remove("drag-over");

    if (event.dataTransfer?.files && event.dataTransfer.files.length > 0) {
      const file = event.dataTransfer.files[0];
      const extension = file.name.split(".").pop()?.toLowerCase();
      const formatos = this.formatosPermitidosLiderazgo;

      if (!extension || !formatos.includes(extension)) {
        Swal.fire("Formato invalido", `Solo se aceptan: ${this.formatosPermitidosLiderazgoTexto || ".pdf, .doc, .docx"}`, "warning");
        event.dataTransfer.clearData();
        return;
      }

      this.archivoSeleccionado = file;
      this.archivoDigitalLiderazgo.file = file;
      this.estadoSubida = "";
      this.mensajeSubida = "";
      this.progresoSubida = 0;
      event.dataTransfer.clearData();
    }
  }

  eliminarArchivo(): void {
    this.archivoSeleccionado = null;
    this.archivoDigitalLiderazgo.file = null;
    this.estadoSubida = "";
    this.mensajeSubida = "";
    this.progresoSubida = 0;
  }

  eliminarArchivoEditar(): void {
    this.archivoSeleccionadoEditar = null;
  }

  

  //obtiene el estado de los documentos para mostrar en el historial de liderazgo y compromiso
  getEstadoDocumento(): void {
  
    this.estadoDocumentosService.getAllEstados()
      .subscribe({
  
        next: (resp: any) => {
  
        //  console.log('Estados:', resp);
          this.estadosPolitica = resp;
          
        },
  
        error: (error) => {
  
          console.error(error);
  
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'No fue posible cargar los estados del documento.'
          });
  
        }
  
      });
  
  }

  
  private cargarConsecutivos(): void {
    this.liderazgoPesvService.getConsecutivo().subscribe({
      next: (data) => {
        const valorConsecutivo = data && typeof data === 'object'
          ? data?.consecutivo ?? data?.value ?? data?.numero ?? data?.id ?? null
          : data;

       // console.log('Consecutivo de liderazgo y compromiso:', valorConsecutivo);
        this.consecutivoLiderazgo = valorConsecutivo ?? null;

        if (this.formLiderazgo?.get('consecutivo')) {
          this.formLiderazgo.patchValue({ consecutivo: this.consecutivoLiderazgo }, { emitEvent: false });
        }
      },
      error: () => {
        console.error('Error al cargar el consecutivo de liderazgo y compromiso');
      },
    });
  }

   guardarActaLiderazgo(): void {
    if (!this.formLiderazgo.valid) {
      this.formLiderazgo.markAllAsTouched();
      Swal.fire("Validacion", "Completa todos los campos requeridos", "warning");
      return;
    }

    this.cargando = true;

    const fecha = String(this.formLiderazgo.get("fecha")?.value || "").trim();
    const version = this.normalizarVersionLiderazgo(this.formLiderazgo.get("version")?.value);
    const consecutivo = this.formLiderazgo.get("consecutivo")?.value || null;
    const estado = this.formLiderazgo.get("estado")?.value || null;
    const observaciones = String(this.formLiderazgo.get("observaciones")?.value || "").trim();
    const archivoSeleccionado = this.archivoSeleccionado;

    const payload = {
      version,
      consecutivo,
      fecha,
      estado,
      observaciones,
    };

    if (archivoSeleccionado && !this.empresaNit) {
      this.cargando = false;
      Swal.fire("Error", "No se pudo obtener el NIT de la empresa para cargar el soporte.", "error");
      return;
    }

    const nombreCarpeta = `${this.empresaNit || "nit"}/pesv/documental/acta/liderazgo/${version}`;
    const nombreArchivo = "ACTA_LIDERAZGO_"+version 
    const prefijo = "ACTA_LIDERAZGO";
    const idNumerico = Number(this.archivoDigitalLiderazgo.id || 4);

    if (this.editando && this.liderazgoEditandoId) {
      //aqui actualiza el acta de liderazgo y compromiso existente
      console.log("Actualizando liderazgo y compromiso existente con ID:", this.liderazgoEditandoId);
    //  console.log("Payload de actualización:", payload);
      this.liderazgoPesvService.update(this.liderazgoEditandoId as string | number, payload).subscribe({
        next: () => {
          if (!archivoSeleccionado) {
            this.cargando = false;
            Swal.fire("Exito", "Liderazgo y compromiso actualizado correctamente", "success");
             this.cargarHistorialActas();
            this.formLiderazgo.reset();
            this.fechaVencimientoMin = "";
            this.eliminarArchivo();
            this.editando = false;
            this.liderazgoEditandoId = null;
            return;
          }else{
            this.cargando = false;
           // Swal.fire("Exito", "Liderazgo y compromiso actualizado correctamente", "success");
            this.cargarHistorialActas();
            this.formLiderazgo.reset();
            this.fechaVencimientoMin = "";
            this.eliminarArchivo();
            this.editando = false;
            this.liderazgoEditandoId = null;
              this.digitalesService.subirArchivo(archivoSeleccionado as File, idNumerico, nombreCarpeta, nombreArchivo, prefijo).subscribe({
              next: (event) => {
                if (event.type === HttpEventType.UploadProgress && event.total) {
                  this.progresoSubida = Math.round((100 * event.loaded) / event.total);
                } else if (event.type === HttpEventType.Response) {
                  this.cargando = false;
                  this.estadoSubida = "exito";
                  this.mensajeSubida = "Soporte cargado exitosamente.";
                  this.subiendoArchivo = false;
                  Swal.fire("Exito", "Liderazgo y compromiso guardado correctamente", "success");
                  this.formLiderazgo.reset();
                  this.fechaVencimientoMin = "";
                  this.eliminarArchivo();
                  this.removePdfActaSeleccionado();
                   this.cargarHistorialActas();
                }
              },
              error: () => {
                this.cargando = false;
                this.estadoSubida = "error";
                this.mensajeSubida = "Error al cargar el soporte.";
                this.subiendoArchivo = false;
                Swal.fire("Error", "Se guardó el liderazgo, pero no se pudo cargar el soporte.", "error");
              },
            });
          }
          // Si hay archivo, deja cargando activo para la subida del archivo
        },
        error: (err) => {
          this.cargando = false;
          Swal.fire("Error", "No se pudo actualizar el liderazgo y compromiso.", "error");
        },
      });

    }else{
 this.liderazgoPesvService.getAll().subscribe({
      next: (items: any[]) => {
        const existente = (Array.isArray(items) ? items : []).find(
          (it: any) => this.normalizarVersionLiderazgo(it?.version || "") === version,
        );

        const guardar$ = existente
          ? this.liderazgoPesvService.update(existente.id, payload)
          : this.liderazgoPesvService.create(payload);

        this.estadoSubida = archivoSeleccionado ? "subiendo" : "";
        this.progresoSubida = 0;
        this.mensajeSubida = "";
        this.subiendoArchivo = !!archivoSeleccionado;

        guardar$.subscribe({
          next: () => {
            if (!archivoSeleccionado) {
              this.cargando = false;
              this.estadoSubida = "exito";
              this.mensajeSubida = "Registro guardado correctamente.";
              this.subiendoArchivo = false;
              Swal.fire("Exito", "Liderazgo y compromiso guardado correctamente", "success");
              this.formLiderazgo.reset();
              this.fechaVencimientoMin = "";
              this.eliminarArchivo();
             
              return;
            }

            this.digitalesService.subirArchivo(archivoSeleccionado as File, idNumerico, nombreCarpeta, nombreArchivo, prefijo).subscribe({
              next: (event) => {
                if (event.type === HttpEventType.UploadProgress && event.total) {
                  this.progresoSubida = Math.round((100 * event.loaded) / event.total);
                } else if (event.type === HttpEventType.Response) {
                  this.cargando = false;
                  this.estadoSubida = "exito";
                  this.mensajeSubida = "Soporte cargado exitosamente.";
                  this.subiendoArchivo = false;
                  Swal.fire("Exito", "Liderazgo y compromiso guardado correctamente", "success");
                  this.formLiderazgo.reset();
                  this.fechaVencimientoMin = "";
                  this.eliminarArchivo();
                   this.cargarHistorialActas();
                }
              },
              error: () => {
                this.cargando = false;
                this.estadoSubida = "error";
                this.mensajeSubida = "Error al cargar el soporte.";
                this.subiendoArchivo = false;
                Swal.fire("Error", "Se guardó el liderazgo, pero no se pudo cargar el soporte.", "error");
              },
            });
          },
          error: (err) => {
            this.cargando = false;
            this.estadoSubida = "error";
            this.subiendoArchivo = false;
            Swal.fire("Error", this.obtenerMensajeError(err, "No se pudo guardar liderazgo y compromiso"), "error");
          },
        });
      },
      error: (err) => {
        this.cargando = false;
        this.estadoSubida = "error";
        this.subiendoArchivo = false;
        Swal.fire("Error", this.obtenerMensajeError(err, "No se pudo validar versiones de liderazgo"), "error");
      },
    });
    }
   
  }

    /**
   * Manejar selección de archivo PDF
   */
  onPdfFileSelected(event: any): void {
    const file = event?.target?.files?.[0];
    if (!file) {
      return;
    }

    this.asignarPdfActaSeleccionado(file);
    event.target.value = "";
  }

  onDragOverPdfActa(event: DragEvent): void {
    event.preventDefault();
    const target = event.currentTarget as HTMLElement;
    target.classList.add("drag-over");
  }

  onDragLeavePdfActa(event: DragEvent): void {
    event.preventDefault();
    const target = event.currentTarget as HTMLElement;
    target.classList.remove("drag-over");
  }

  onDropPdfActa(event: DragEvent): void {
    event.preventDefault();
    const target = event.currentTarget as HTMLElement;
    target.classList.remove("drag-over");

    const file = event.dataTransfer?.files?.[0];
    if (!file) {
      return;
    }

    this.asignarPdfActaSeleccionado(file);
    event.dataTransfer?.clearData();
  }
    private asignarPdfActaSeleccionado(file: File): void {
      const extension = file.name.split(".").pop()?.toLowerCase() || "";
      if (extension !== "pdf") {
        Swal.fire("Error", "Solo se permiten archivos PDF", "error");
        this.pdfFileSelected = null;
        return;
      }
  
      // Validar tamaño (máximo 10MB)
      const maxSize = 10 * 1024 * 1024; // 10MB
      if (file.size > maxSize) {
        Swal.fire("Error", "El archivo no debe superar los 10MB", "error");
        this.pdfFileSelected = null;
        this.archivoSeleccionado = null;
        this.archivoDigitalLiderazgo.file = null;
        return;
      }
  
      this.pdfFileSelected = file;
      this.archivoSeleccionado = file;
      this.archivoDigitalLiderazgo.file = file;
      this.estadoSubida = "";
      this.mensajeSubida = "";
      this.progresoSubida = 0;
      console.log(
        "✅ Archivo PDF seleccionado:",
        file.name,
        this.formatFileSize(file.size),
      );
    }

     /**
   * Formatear tamaño de archivo
   */
  formatFileSize(bytes: number): string {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + " " + sizes[i];
  }

   removePdfActaSeleccionado(): void {
    this.pdfFileSelected = null;
    this.archivoSeleccionado = null;
    this.archivoDigitalLiderazgo.file = null;
  }


  cargarHistorialActas(): void {
    this.cargandoHistorial = true;
    this.liderazgoPesvService.getAll().subscribe({
      next: (data: any[]) => {
        this.historialActas = Array.isArray(data) ? data : [];
        this.cargandoHistorial = false;
        this.historialInicialCargado = true;

        //VALIDAMOS SI HAY UNA ACTA VIGENTE PARA CONTROLAR EL BOTON DE CREAR NUEVO LIDERAZGO Y COMPROMISO
        const actaVigente = this.historialActas.find((item) => this.esLiderazgoActivo(item));
        this.actaVigenteExiste = !!actaVigente;
      



      },
      error: (err) => {
        this.cargandoHistorial = false;
        Swal.fire("Error", this.obtenerMensajeError(err, "No se pudo cargar el historial de liderazgo y compromiso"), "error");
      },
    });
  }

  inactivarLiderazgoDesdeHistorial(item: any): void {
    console.log("Intentando inactivar liderazgo y compromiso desde historial:", item);
    if (!item || item.id == null) {
      Swal.fire("Error", "No se encontro el identificador de liderazgo y compromiso.", "error");
      return;
    }

    //vamos a rechzar el liderazgo y compromiso
    Swal.fire({
      title: "Confirmar accion",
      text: "¿Deseas inactivar liderazgo y compromiso?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Si",
      cancelButtonText: "No",
    }).then((result) => {
      if (!result.isConfirmed) {
        return;
      }
      //llamamos al servicio para inactivar el liderazgo y compromiso
      this.liderazgoPesvService.inactivar(item.id).subscribe({
        next: () => {
          item.estado = 5; // Actualizamos el estado a RECHAZADO (5) en el historial
          Swal.fire("Exito", "Liderazgo y compromiso inactivado correctamente.", "success");
          this.cargarHistorialActas();
        },
        error: (err) => {
          Swal.fire("Error", this.obtenerMensajeError(err, "No se pudo inactivar liderazgo y compromiso."), "error");
        },
      });
    });
  }

  getClaseEstado(estado: string): string {
  switch (estado?.toLowerCase()) {
    case 'borrador':
      return 'badge bg-secondary';
    case 'obsoleto':
      return 'badge badge-light-info';
    case 'en revisión':
    case 'revision':
    return 'badge badge-light-warning ';
  

    case 'rechazada':
       case 'vencida':
      return 'badge badge-light-secondary';

    case 'vigente':
      return 'badge badge-light-success';

    default:
      return 'badge bg-light text-dark';
  }
}

  visualizarPDF(version: string): void {
                  
        if (!version) {
          Swal.fire("Error", "No se puede visualizar sin ID", "error");
          return;
        }
        Swal.fire({
          title: "Confirmar visualización",
          text: "¿Deseas visualizar el documento: Acta Comité PESV?",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Visualizar",
          cancelButtonText: "Cancelar",
        }).then((result) => {
          if (!result.isConfirmed) {
            return;
          }
    
         
          if (!this.empresaNit) {
            Swal.close();
            Swal.fire(
              "Error",
              "No se pudo obtener el NIT de la empresa para visualizar el documento.",
              "error",
            );
            return;
          }
    
          const rutaActaLiderazgo = `${this.empresaNit}/pesv/documental/acta/liderazgo/${version}/ACTA_LIDERAZGO_documental.pdf`;
    
          this.gpcGoogle.getSignedUrlFiles(rutaActaLiderazgo).subscribe({
            next: (resp) => {
              Swal.close();
              if (!resp?.url) {
                
                Swal.fire(
                  "Error",
                  "No se pudo obtener la URL del documento del comité PESV.",
                  "error",
                );
                return;
              }
    
              this.googleStoragePreview.open(resp.url, "Acta comité PESV");
             
            },
            error: (err) => {
              
              Swal.close();
              console.error(
                "❌ Error al obtener la URL del documento del comité PESV.",
                err,
              );
              Swal.fire(
                "Error",
                "No se pudo obtener la URL del documento del comité PESV.",
                "error",
              );
            },
          });
    
    
        
    
          
        });
   }

  VerDocumentoLiderazgo(version: string): void {
    if (!version) {
      Swal.fire("Error", "No se puede visualizar sin ID", "error");
      return;
    }

    this.visualizarPDF(version);
  }
   

     descargarDocumentoComite(version: string): void {
         if (!version) {
           Swal.fire("Error", "No se puede descargar sin ID", "error");
           return;
         }
     
         // const id = Number(idComite);
         // if (Number.isNaN(id)) {
         //   Swal.fire("Error", "ID de comité inválido.", "error");
         //   return;
         // }
     
       
         Swal.fire({
           title: "Descargando...",
           text: "Por favor espera mientras se descarga el documento.",
           allowOutsideClick: false,
           allowEscapeKey: false,
           showConfirmButton: false,
           didOpen: () => {
             Swal.showLoading();
           },
         });
     
         const fileName = `ACTA_LIDERAZGO_PESV_${version}.pdf`;
          const descargarConUrl = (url: string) => {
             Swal.close();
             
             this.descargarDesdeUrlFirmada(url, fileName);
           };
       
         
     
         if (!this.empresaNit) {
           Swal.close();
           
           Swal.fire(
             "Error",
             "No se pudo obtener el NIT de la empresa para descargar el documento.",
             "error",
           );
           return;
         }
     
         const rutaComite = `${this.empresaNit}/pesv/documental/acta/liderazgo/${version}/ACTA_LIDERAZGO_documental.pdf`;
      
         this.gpcGoogle.getSignedUrlFiles(rutaComite).subscribe({
           next: (resp) => {
             Swal.close();
             if (!resp?.url) {
              // this.descargandoLiderId = null;
               Swal.fire(
                 "Error",
                 "No se pudo obtener la URL firmada del documento.",
                 "error",
               );
               return;
             }
     
             descargarConUrl(resp.url);
           },
           error: (err) => {
            // this.descargandoLiderId = null;
             Swal.close();
             console.error(
               "❌ Error al obtener la URL firmada del documento del líder PESV.",
               err,
             );
             Swal.fire(
               "Error",
               "No se pudo obtener la URL firmada del documento.",
               "error",
             );
           },
         });
     }

       private descargarDesdeUrlFirmada(url: string, fileName: string): void {
         fetch(url)
           .then((response) => {
             if (!response.ok) {
               throw new Error(`Error al descargar archivo: ${response.status}`);
             }
             return response.blob();
           })
           .then((blob) => {
             const objectUrl = window.URL.createObjectURL(blob);
             const enlace = document.createElement("a");
             enlace.href = objectUrl;
             enlace.download = fileName;
             enlace.style.display = "none";
             document.body.appendChild(enlace);
             enlace.click();
             document.body.removeChild(enlace);
             window.URL.revokeObjectURL(objectUrl);
           })
           .catch((error) => {
             console.error("Error al descargar URL firmada:", error);
             Swal.fire("Error", "No se pudo descargar el documento.", "error");
           });
       }
}
